// extracted by mini-css-extract-plugin
export default {"errors__alert":"Errors_errors__alert__4ZWLn","errors__actions":"Errors_errors__actions__8NuNc","errors__action-button":"Errors_errors__action-button__K8OMn"};